
/* Nautiya SKIN JS : (1) image description metafield ; (2) galerie dots mobile ; (3) galerie miniatures desktop : le BOUTON ROND change l'image principale (suivante en boucle) — handler POSITION-BASED delegue en capture + fallback direct ; clic vignette natif inchange. */
(function(){
  var IS_DESIGN = (window.Shopify && window.Shopify.designMode);

  function readMetaImg(){
    try{
      var node=document.getElementById('nty-desc-img-data');
      if(!node) return '';
      var raw=(node.textContent||'').trim();
      if(!raw) return '';
      var url;
      try{ url=JSON.parse(raw); }catch(e){ url=raw; }
      if(typeof url!=='string') return '';
      url=url.trim();
      if(!url) return '';
      if(url.indexOf('//')===0) url='https:'+url;
      return url;
    }catch(e){ return ''; }
  }
  function setDescImg(){
    try{
      var url=readMetaImg();
      if(!url) return;
      var span=document.getElementById('nty-desc-img');
      if(span && span.getAttribute('data-src')!==url){ span.setAttribute('data-src',url); }
      var img=document.getElementById('nty-desc-img-el');
      if(img && img.getAttribute('data-nty-applied')!==url){
        img.src=url;
        img.setAttribute('data-nty-applied',url);
      }
    }catch(e){}
  }

  function galleryMode(){ try{ return (window.__ntyGalleryMode||document.documentElement.getAttribute('data-nty-gallery')||'miniatures'); }catch(e){ return 'miniatures'; } }
  var MQ=null; try{ MQ=window.matchMedia('(max-width:768px)'); }catch(e){ MQ=null; }
  function isMobile(){ try{ return MQ ? MQ.matches : (window.innerWidth<=768); }catch(e){ return false; } }
  function isDesktop(){ return !isMobile(); }
  function dotsEffective(){ return galleryMode()==='dots' && isMobile(); }

  function getWrap(){ return document.querySelector('[class*="mz-main-img-wrap-"]'); }
  function getGallery(){
    var w=getWrap();
    if(w){ var g=w.closest ? w.closest('[class*="mz-gallery"]') : null; if(g) return g; }
    return w ? (w.parentElement||document) : document;
  }
  function getSlides(wrap){
    var scope = wrap || getWrap();
    if(!scope){
      return Array.prototype.slice.call(document.querySelectorAll('[class*="mz-main-img-"]'))
        .filter(function(el){ return el.tagName==='IMG' && !/wrap/i.test(el.className||''); });
    }
    return Array.prototype.slice.call(scope.querySelectorAll('[class*="mz-main-img-"]'))
      .filter(function(el){ return el.tagName==='IMG' && !/wrap/i.test(el.className||''); });
  }
  function getMainSlides(){ return getSlides(getWrap()); }
  function getThumbsWrap(){ return document.querySelector('[class*="mz-thumbs-"]:not([class*="mz-thumbs-scroll"])') || document.querySelector('[class*="mz-thumbs-"]'); }
  function getThumbs(){
    var tw=getThumbsWrap();
    var list = tw ? Array.prototype.slice.call(tw.querySelectorAll('[class*="mz-thumb-"][data-index]')) : [];
    if(!list.length){ list = Array.prototype.slice.call(document.querySelectorAll('[class*="mz-thumb-"][data-index]')); }
    return list.filter(function(t){ return !isNaN(parseInt(t.getAttribute('data-index'),10)); });
  }
  function getThumbsBar(){ return document.querySelector('[class*="mz-thumbs-"]:not([class*="mz-thumbs-scroll"])') || document.querySelector('[class*="mz-thumbs-"]'); }

  function getHideTargets(){
    var sels=['[class*="mz-thumbs-"]','[class*="mz-thumb-scroll"]','[class*="mz-gallery-dots-"]','[id*="mzThumbs"]','[id*="mzDots"]'];
    var out=[], seen=[];
    sels.forEach(function(s){
      var nl=document.querySelectorAll(s);
      for(var i=0;i<nl.length;i++){ if(seen.indexOf(nl[i])<0){ seen.push(nl[i]); out.push(nl[i]); } }
    });
    return out;
  }
  function getScrollable(wrap){
    if(!wrap) return null;
    var el=wrap, hops=0;
    while(el && hops<4){
      try{ if(el.scrollWidth - el.clientWidth > 4) return el; }catch(e){}
      el=el.parentElement; hops++;
    }
    return null;
  }
  function existingBar(){ return document.querySelector('.nty-gdots'); }
  function removeBar(){ var b=existingBar(); if(b && b.parentNode){ b.parentNode.removeChild(b); } }

  function hideThumbs(on){
    var targets=getHideTargets();
    if(!targets.length) return;
    targets.forEach(function(tw){
      if(on){
        if(!tw.hasAttribute('data-nty-thumbs-prev')){ tw.setAttribute('data-nty-thumbs-prev', tw.style.display||''); }
        tw.style.display='none';
      } else {
        if(tw.hasAttribute('data-nty-thumbs-prev')){
          tw.style.display = tw.getAttribute('data-nty-thumbs-prev');
          tw.removeAttribute('data-nty-thumbs-prev');
        } else if(tw.style.display==='none'){ tw.style.display=''; }
      }
    });
  }

  function setActiveDots(dots,i){ dots.forEach(function(d,j){ d.classList.toggle('is-active',j===i); }); }
  function currentIndexToggle(slides){
    for(var i=0;i<slides.length;i++){
      try{ if(window.getComputedStyle(slides[i]).display!=='none') return i; }catch(e){}
    }
    return 0;
  }

  function buildDots(){
    try{
      if(!dotsEffective()) return false;
      if(IS_DESIGN) return false;
      if(existingBar()) return true;
      var wrap=getWrap();
      if(!wrap) return false;
      var slides=getSlides(wrap);
      var thumbs=getThumbs();
      var count=Math.max(slides.length, thumbs.length);
      if(!count) return false;

      var scrollable=getScrollable(wrap);

      var dotsBar=document.createElement('div');
      dotsBar.className='nty-gdots';
      dotsBar.setAttribute('role','tablist');
      var dots=[];
      for(var i=0;i<count;i++){
        (function(idx){
          var b=document.createElement('button');
          b.type='button';
          b.className='nty-gdots__dot'+(idx===0?' is-active':'');
          b.setAttribute('aria-label','Image '+(idx+1));
          b.addEventListener('click',function(){
            var sc=getScrollable(getWrap());
            if(sc){
              var sw=sc.clientWidth||1;
              try{ sc.scrollTo({left:idx*sw, behavior:'smooth'}); }catch(e){ sc.scrollLeft=idx*sw; }
            }
            var t=getThumbs()[idx];
            if(t && typeof t.click==='function'){ t.click(); }
            else if(!sc){ getSlides(getWrap()).forEach(function(s,j){ s.style.display=(j===idx)?'block':'none'; }); }
            setActiveDots(dots,idx);
          });
          dotsBar.appendChild(b);
          dots.push(b);
        })(i);
      }

      if(wrap.parentNode){ wrap.parentNode.insertBefore(dotsBar, wrap.nextSibling); }
      else { wrap.appendChild(dotsBar); }

      if(scrollable){
        var ticking=false;
        var onScroll=function(){
          if(ticking) return;
          ticking=true;
          window.requestAnimationFrame(function(){
            ticking=false;
            var sw=scrollable.clientWidth||1;
            var idx=Math.round(scrollable.scrollLeft / sw);
            if(idx<0) idx=0; if(idx>count-1) idx=count-1;
            setActiveDots(dots,idx);
          });
        };
        scrollable.addEventListener('scroll', onScroll, {passive:true});
        onScroll();
      } else {
        setActiveDots(dots, currentIndexToggle(slides));
        if(slides.length){
          var mo=new MutationObserver(function(){ setActiveDots(dots, currentIndexToggle(slides)); });
          slides.forEach(function(s){ mo.observe(s,{attributes:true,attributeFilter:['style','class']}); });
        }
        if(thumbs.length){
          var mo2=new MutationObserver(function(){
            var ai=-1;
            for(var k=0;k<thumbs.length;k++){ if(thumbs[k].classList.contains('active')){ ai=k; break; } }
            if(ai>=0) setActiveDots(dots,ai);
          });
          thumbs.forEach(function(t){ mo2.observe(t,{attributes:true,attributeFilter:['class']}); });
        }
      }

      hideThumbs(true);
      return true;
    }catch(e){ return false; }
  }

  function reconcileDots(){
    try{
      if(dotsEffective() && !IS_DESIGN){ buildDots(); hideThumbs(true); }
      else { removeBar(); hideThumbs(false); }
    }catch(e){}
  }

  /* ===== TACHE 3 : le BOUTON ROND change l'image principale — POSITION-BASED + fallback ===== */
  function visibleSlideIndex(slides){
    for(var i=0;i<slides.length;i++){
      try{ if(window.getComputedStyle(slides[i]).display!=='none') return i; }catch(e){}
    }
    return -1;
  }
  function applySlidePosition(next){
    /* Fallback direct : bascule les slides par POSITION + pose .active sur la vignette next */
    var slides=getMainSlides();
    if(slides.length){
      slides.forEach(function(s,j){
        s.style.display = (j===next) ? 'block' : 'none';
        if(j!==0){ s.style.position = (j===next) ? 'relative' : 'absolute'; }
      });
    }
    var thumbs=getThumbs();
    thumbs.forEach(function(t,j){ t.classList.toggle('active', j===next); });
  }

  function goNextByPosition(){
    try{
      var thumbs=getThumbs();
      if(!thumbs.length) return;
      var active=-1;
      for(var i=0;i<thumbs.length;i++){ if(thumbs[i].classList.contains('active')){ active=i; break; } }
      if(active<0){ active = Math.max(0, visibleSlideIndex(getMainSlides())); }
      if(active<0) active=0;
      var next=(active+1) % thumbs.length;
      var slides=getMainSlides();
      var beforeVisible=visibleSlideIndex(slides);

      /* 1) declenche le showImage natif via clic vignette (fonctionne deja au clic vignette) */
      if(typeof thumbs[next].click==='function'){ thumbs[next].click(); }

      /* 2) rend la vignette cible visible dans la bande */
      try{ thumbs[next].scrollIntoView({block:'nearest', inline:'nearest'}); }catch(e){ try{ thumbs[next].scrollIntoView(false); }catch(e2){} }

      /* 3) FALLBACK : si l'image visible n'a pas change ~40ms apres, bascule directement par position */
      setTimeout(function(){
        try{
          var s2=getMainSlides();
          var nowVisible=visibleSlideIndex(s2);
          if(nowVisible===beforeVisible || nowVisible!==next){
            applySlidePosition(next);
          }
        }catch(e){}
      }, 40);
    }catch(e){}
  }

  function updateThumbsOverflow(){
    try{
      var bar=getThumbsBar();
      if(!bar) return;
      var n=getThumbs().length; if(!n){ n=getMainSlides().length; }
      bar.classList.toggle('nty-thumbs-noscroll', n<=1);
    }catch(e){}
  }

  var scrollBtnDelegated=false;
  function wireScrollButton(){
    try{
      if(scrollBtnDelegated) return;
      scrollBtnDelegated=true;
      document.addEventListener('click', function(ev){
        try{
          var btn = ev.target && ev.target.closest ? ev.target.closest('[class*="mz-thumb-scroll-btn-"]') : null;
          if(!btn) return;
          if(!isDesktop()) return; /* gate desktop */
          ev.preventDefault(); ev.stopPropagation();
          goNextByPosition();
        }catch(e){}
      }, true); /* capture */
    }catch(e){}
  }

  function reconcileThumbs(){
    try{
      if(IS_DESIGN) return;
      wireScrollButton();
      if(isDesktop()){ updateThumbsOverflow(); }
    }catch(e){}
  }

  var descTries=0, dotsTries=0;

  function tick(){
    setDescImg();
    reconcileDots();
    reconcileThumbs();
    var dotsDone = !dotsEffective() || IS_DESIGN || !!existingBar();
    var im=document.getElementById('nty-desc-img-el');
    var descDone = !document.getElementById('nty-desc-img-data') || (im && im.getAttribute('data-nty-applied'));
    return (dotsDone && descDone);
  }

  function boot(){
    tick();
    var iv=setInterval(function(){
      descTries++; dotsTries++;
      var done=tick();
      if(done || (descTries>20 && dotsTries>20)) clearInterval(iv);
    },300);

    try{
      var mo=new MutationObserver(function(){ setDescImg(); reconcileDots(); reconcileThumbs(); });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}

    try{
      if(MQ){
        var onMq=function(){ reconcileDots(); reconcileThumbs(); };
        if(MQ.addEventListener){ MQ.addEventListener('change', onMq); }
        else if(MQ.addListener){ MQ.addListener(onMq); }
      }
    }catch(e){}
    try{
      var rt=null;
      window.addEventListener('resize', function(){ if(rt) return; rt=setTimeout(function(){ rt=null; reconcileDots(); reconcileThumbs(); },160); });
    }catch(e){}
  }

  if(document.readyState!=='loading'){ boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  window.addEventListener('load', function(){ setDescImg(); reconcileDots(); reconcileThumbs(); });
  document.addEventListener('shopify:section:load', function(){ scrollBtnDelegated=false; wireScrollButton(); setDescImg(); reconcileDots(); reconcileThumbs(); });
})();
